window.CKB_SEARCH_INDEX = (window.CKB_SEARCH_INDEX || []).concat([
  {
    "id": "CKC-KA-1410",
    "title": "CHA HPD Expansion Kit: What It Is and What It Is Not",
    "handle": "cha-hpd-expansion-kit-what-it-is-and-is-not",
    "quick": "CHA HPD is the optional High Performance Dipole wire-set expansion for CHA TD 2.0. It is not a stand-alone antenna and requires the complete CHA TD 2.0 system, sold separately.",
    "summary": "The controlling classification, required parent system, package contents, military/government field-use context, and purchase boundary for CHA HPD.",
    "category": "Product Compatibility",
    "section": "CHA TD 2.0",
    "keywords": "CHA HPD High Performance Dipole wire set expansion kit accessory not standalone antenna requires CHA TD 2.0 Tactical Dipole two 108 foot wires line winders military government field use",
    "seoTitle": "CHA HPD Expansion Kit for CHA TD 2.0 | CKB",
    "metaDescription": "Learn why CHA HPD is an optional wire-set expansion for CHA TD 2.0, not a stand-alone antenna, and what the complete system requires.",
    "difficulty": "All operators",
    "readingTime": "4–6 min",
    "revision": "1.0",
    "reviewed": "2026-07-22",
    "url": "/pages/chameleon-knowledge-base?article=cha-hpd-expansion-kit-what-it-is-and-is-not",
    "published": true,
    "canonicalHandle": "cha-hpd-expansion-kit-what-it-is-and-is-not",
    "canonicalId": "CKC-KA-1410",
    "editorialStatus": "source_governed",
    "bodyChunk": "30",
    "relatedHeadings": ["Quick Classification", "Required Parent System", "Package Contents", "Military and Government Use", "Purchase Rule", "Documentation Authority"],
    "sourceReviewed": "2026-07-22",
    "sourceAuthority": "CHA TD 2.0 User Guide revision 260723 and manufacturer-owner classification confirmed 2026-07-22",
    "freshnessPolicy": "Review after a TD 2.0 guide, HPD package-content, product-status, compatibility, safety, or documented military/government-use change."
  },
  {
    "id": "CKC-KA-1411",
    "title": "Using CHA HPD with CHA TD 2.0",
    "handle": "using-cha-hpd-with-cha-td-2-0",
    "quick": "Use CHA HPD only inside a complete CHA TD 2.0 deployment and only in the antenna-wire and/or counterpoise-wire positions documented by the current TD 2.0 User Guide.",
    "summary": "A source-governed relationship guide connecting the CHA HPD wire-set expansion to the complete CHA TD 2.0 system, documented configurations, supports, operating limits, and field-use boundary.",
    "category": "Product Installation Guides",
    "section": "CHA TD 2.0",
    "keywords": "CHA HPD CHA TD 2.0 Tactical Dipole installation configuration optional High Performance wire kit antenna wire counterpoise wire 9 configurations 15 configurations military government",
    "seoTitle": "Using CHA HPD with CHA TD 2.0 | CKB",
    "metaDescription": "See how the optional CHA HPD wire set expands a complete CHA TD 2.0 system and which documentation controls every deployment.",
    "difficulty": "Beginner to Intermediate",
    "readingTime": "6–8 min",
    "revision": "1.0",
    "reviewed": "2026-07-22",
    "url": "/pages/chameleon-knowledge-base?article=using-cha-hpd-with-cha-td-2-0",
    "published": true,
    "canonicalHandle": "using-cha-hpd-with-cha-td-2-0",
    "canonicalId": "CKC-KA-1411",
    "editorialStatus": "source_governed",
    "bodyChunk": "30",
    "relatedHeadings": ["System Relationship", "What HPD Adds", "Documented Use", "Configuration Boundary", "Military and Government Field Use", "Safety and Authority"],
    "sourceReviewed": "2026-07-22",
    "sourceAuthority": "CHA TD 2.0 User Guide revision 260723 and manufacturer-owner classification confirmed 2026-07-22",
    "freshnessPolicy": "Review after a TD 2.0 guide, HPD package-content, configuration, compatibility, safety, or documented military/government-use change."
  }
]);
